import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Tarkista osoitteen palvelualue',
  or: 'tai',
  form: {
    company: {
      label: 'Valitse ravintola',
    },
    address: {
      label: 'Kirjoita osoite',
    },
  },
  result: {
    positive: '{{address}} on ulkoisen toimituksen piirissä',
    negative: '{{address}} ei ole ulkoisen toimituksen piirissä',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Tarkista',
  },
  toasts: {
    error: 'Osoitteen palvelualueen tarkistus epäonnistui',
  },
};
